import React, { useState } from 'react'
import DinnersClub from '../../../../assets/icons/svg/dinners_club.svg'
import Amex from '../../../../assets/icons/svg/amex.svg'
import Maestro from '../../../../assets/icons/svg/maestro.svg'
import Elo from '../../../../assets/icons/svg/elo.svg'
import MasterCard from '../../../../assets/icons/svg/master_card.svg'
import Visa from '../../../../assets/icons/svg/visa.svg'
import { IconTrashSvg } from '../../../../assets/icons/svgComponents'
import DeleteCard from './delete-card'
import ActiveCard from './active-card'
import * as S from './styles'
import { useModalBox } from '../../../../contexts'

interface CardInterface {
  nome: string
  ultimos4digitos: string
  bandeira: string
  ativo: boolean
  id: number
}

interface CardPaymentInterface {
  data: CardInterface[]
  onDelete?: (data: any) => Promise<void>
}

const CardPayment = ({ data }: CardPaymentInterface) => {
  const { modalBox } = useModalBox()
  const [selected, setSelected] = useState<number>()

  const getPaymentIcon = (item: CardInterface): JSX.Element => {
    switch (item.bandeira) {
      case 'visa':
        return <img src={Visa} alt={item.bandeira} />
      case 'amex':
        return <img src={Amex} alt={item.bandeira} />
      case 'maestro':
        return <img src={Maestro} alt={item.bandeira} />
      case 'elo':
        return <img src={Elo} alt={item.bandeira} />
      case 'mastercard':
        return <img src={MasterCard} alt={item.bandeira} />
      case 'dinersclub':
        return <img src={DinnersClub} alt={item.bandeira} />
      default:
        return <>{item.bandeira}</>
    }
  }

  const isSelected = (item: CardInterface): boolean => {
    if (selected) {
      return item.id === selected
    }

    return item.ativo
  }

  const onDeleteCard = (item: CardInterface): void => {
    modalBox(<DeleteCard item={item} />, 'Deletar Cartão', '32%')
  }

  const onActiveCard = (item: CardInterface): void => {
    modalBox(<ActiveCard item={item} />, 'Ativar Cartão', '32%')
  }

  return (
    <S.ExternContainer>
      {data.map((item) => (
        <S.CardContainer>
          <S.Header>
            {selected === item.id && !item.ativo && (
              <button type="button" onClick={() => onActiveCard(item)}>
                Ativar
              </button>
            )}

            <div onClick={() => onDeleteCard(item)}>
              <IconTrashSvg width={22} height={22} />
            </div>
          </S.Header>

          <S.BackDropCard
            onClick={() => setSelected(item?.id)}
            style={{ borderWidth: isSelected(item) ? 3 : 0 }}
          >
            <S.Card>
              <S.Line>
                <S.Field>
                  <span>{getPaymentIcon(item)}</span>
                </S.Field>
                <S.Field>
                  <span className="active">{item.ativo && 'Ativo'}</span>
                </S.Field>
              </S.Line>

              <S.Line>
                <S.Field>
                  <label></label>
                  <span>**** **** **** {item.ultimos4digitos}</span>
                </S.Field>
              </S.Line>

              <S.Line>
                <S.Field>
                  <label>Nome</label>
                  <span>{item.nome}</span>
                </S.Field>
                <S.Field>
                  <label>Validade</label>
                  <span>08/22</span>
                </S.Field>
              </S.Line>
            </S.Card>
          </S.BackDropCard>
        </S.CardContainer>
      ))}
    </S.ExternContainer>
  )
}

export default CardPayment
